import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "flex items-start gap-4 border-b border-ewhite-200 px-6 py-5" };
const _hoisted_3 = { class: "flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full border border-ewhite-200 bg-eblack-50 text-xl font-bold text-eblack-700" };
const _hoisted_4 = { class: "min-w-0 flex-1" };
const _hoisted_5 = { class: "flex items-center gap-2.5" };
const _hoisted_6 = { class: "text-xl font-bold tracking-tight text-eblack-900" };
const _hoisted_7 = { class: "rounded-full bg-egreen-100 px-2.5 py-1 text-xs font-semibold text-egreen-700" };
const _hoisted_8 = { class: "mt-1.5 flex items-center gap-1.5 text-sm text-eblack-500" };
const _hoisted_9 = ["aria-label"];
const _hoisted_10 = { class: "flex flex-col gap-6 overflow-y-auto px-6 py-6" };
const _hoisted_11 = { class: "flex flex-col gap-2" };
const _hoisted_12 = { class: "text-[13px] font-bold text-eblack-900" };
const _hoisted_13 = { class: "text-sm leading-relaxed text-eblack-600" };
const _hoisted_14 = {
    key: 0,
    class: "flex flex-col gap-2"
};
const _hoisted_15 = { class: "text-[13px] font-bold text-eblack-900" };
const _hoisted_16 = { class: "flex flex-wrap gap-1.5" };
const _hoisted_17 = { class: "grid grid-cols-1 gap-2.5 sm:grid-cols-3" };
const _hoisted_18 = { class: "rounded-xl bg-ewhite-50 p-3" };
const _hoisted_19 = { class: "text-[11px] font-bold uppercase tracking-wide text-eblack-400" };
const _hoisted_20 = { class: "mt-1 text-sm text-eblack-700" };
const _hoisted_21 = { class: "rounded-xl bg-ewhite-50 p-3" };
const _hoisted_22 = { class: "text-[11px] font-bold uppercase tracking-wide text-eblack-400" };
const _hoisted_23 = { class: "mt-1 text-sm text-eblack-700" };
const _hoisted_24 = { class: "rounded-xl bg-ewhite-50 p-3" };
const _hoisted_25 = { class: "text-[11px] font-bold uppercase tracking-wide text-eblack-400" };
const _hoisted_26 = { class: "mt-1 text-sm font-medium text-egreen-700" };
const _hoisted_27 = {
    key: 1,
    class: "flex flex-col gap-2 border-t border-ewhite-200 pt-5"
};
const _hoisted_28 = { class: "text-[13px] font-bold text-eblack-900" };
const _hoisted_29 = { class: "flex flex-col" };
const _hoisted_30 = { class: "min-w-0 flex-1 text-sm font-medium leading-snug text-eblack-800" };
const _hoisted_31 = {
    key: 0,
    class: "flex-shrink-0 rounded-full bg-ewhite-100 px-2.5 py-0.5 text-xs font-medium text-eblack-600"
};
const _hoisted_32 = { class: "flex justify-end border-t border-ewhite-200 px-6 py-4" };
import { computed } from "vue";
import { IconMapPin, IconX } from "@tabler/icons-vue";
import { getCountryName } from "@/utils/country-name";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProviderCatalogDetailModal',
    props: {
        provider: {}
    },
    emits: ["close"],
    setup(__props) {
        const props = __props;
        const initials = computed(() => props.provider.name
            .split(/\s+/)
            .filter(Boolean)
            .slice(0, 2)
            .map((word) => word[0]?.toUpperCase() ?? "")
            .join(""));
        const locationLabel = computed(() => {
            const country = props.provider.country_name || getCountryName(props.provider.country);
            return [
                country,
                props.provider.location_one,
                props.provider.location_two,
                props.provider.location_three,
            ]
                .filter(Boolean)
                .join(", ");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "flex max-h-[90vh] w-full flex-col overflow-hidden rounded-2xl bg-white shadow-xl",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": __props.provider.name
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(initials.value), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.provider.name), 1),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("provider.auto.activo")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(IconMapPin), { class: "h-3.5 w-3.5 flex-shrink-0 text-eorange-500" }),
                            _createElementVNode("span", null, _toDisplayString(locationLabel.value || _ctx.$t("provider.auto.ubicacion_no_especificada")) + " · " + _toDisplayString(_ctx.$t("provider.auto.n_servicios", { count: __props.provider.service_count })), 1)
                        ])
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-eblack-500 transition hover:bg-ewhite-100",
                        "aria-label": _ctx.$t('provider.auto.cerrar'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                    }, [
                        _createVNode(_unref(IconX), { class: "h-5 w-5" })
                    ], 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("provider.auto.acerca_del_proveedor")), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(__props.provider.description || _ctx.$t("provider.auto.sin_descripcion_disponible")), 1)
                    ]),
                    (__props.provider.categories.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("provider.auto.categorias")), 1),
                            _createElementVNode("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.provider.categories, (category) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        key: category,
                                        class: "rounded-full bg-ewhite-100 px-3 py-1 text-xs font-medium text-eblack-600"
                                    }, _toDisplayString(category), 1));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("provider.auto.ubicacion")), 1),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(locationLabel.value || _ctx.$t("provider.auto.ubicacion_no_especificada")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("provider.auto.servicios")), 1),
                            _createElementVNode("p", _hoisted_23, _toDisplayString(__props.provider.service_count), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("provider.auto.estado")), 1),
                            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("provider.auto.activo")), 1)
                        ])
                    ]),
                    (__props.provider.services.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t("provider.auto.servicios")) + " (" + _toDisplayString(__props.provider.services.length) + ") ", 1),
                            _createElementVNode("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.provider.services, (service, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: service.id,
                                        class: _normalizeClass(["flex items-start justify-between gap-3 py-2.5", index < __props.provider.services.length - 1 ? 'border-b border-ewhite-100' : ''])
                                    }, [
                                        _createElementVNode("span", _hoisted_30, _toDisplayString(service.name), 1),
                                        (service.category_name)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(service.category_name), 1))
                                            : _createCommentVNode("", true)
                                    ], 2));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg border border-ewhite-300 px-4 py-2 text-sm font-semibold text-eblack-600 transition hover:bg-ewhite-100",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                    }, _toDisplayString(_ctx.$t("provider.auto.cerrar")), 1)
                ])
            ], 8, _hoisted_1));
        };
    }
});
